/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMoonFilled: {
  name: 'moon-filled';
  data: string;
} = {
  name: 'moon-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.08 3.181a.972.972 0 0 0-.576.507c-.153.305-.141.535.055 1.048.3.789.44 1.509.44 2.264a6.01 6.01 0 0 1-4.123 5.696 5.38 5.38 0 0 1-1.656.293 5.826 5.826 0 0 1-2.474-.431c-.492-.197-.746-.21-1.058-.054-.329.164-.568.528-.568.867 0 .481.413 1.8.821 2.622.91 1.832 2.272 3.185 4.119 4.089 1.341.657 2.411.899 3.96.897.982-.002 1.389-.051 2.282-.279 3.132-.8 5.66-3.371 6.432-6.543a9.022 9.022 0 0 0-3.854-9.715c-.85-.551-2.063-1.053-2.994-1.239-.478-.096-.56-.098-.806-.022"/></svg>`
};
